module.exports = __webpack_public_path__ + "static/media/backgroud.69e1a605.mp3";